import React from 'react';
import cryingBearImage from '@/assets/app/images/common/bottom/crying-bear.png';
import AppButton from '@/shared/components/ui/new/AppButton';

interface MessageSheetProps {
  type: 'INFO' | 'ALERT' | 'CONFIRM';
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  onConfirmTitle?: string;
  onCancelTitle?: string;
  /** 지정 시 메시지 텍스트 폰트 크기(px)를 이 값으로 덮어쓴다 */
  messageFontSize?: number;
}

export const MessageSheet: React.FC<MessageSheetProps> = ({
  type = 'INFO',
  message,
  onConfirm,
  onCancel,
  onConfirmTitle,
  onCancelTitle,
  messageFontSize,
}) => {
  return (
    <div className="p-6 space-y-6">
      {/* 캐릭터 이미지 */}
      {type === 'ALERT' && (
        <div className="flex justify-center">
          <img src={cryingBearImage} alt="울고있는 캐릭터" />
        </div>
      )}

      {/* 메시지 */}
      <h2
        className="text-xl font-bold text-center"
        style={messageFontSize ? { fontSize: messageFontSize } : undefined}
        dangerouslySetInnerHTML={{ __html: message }}
      ></h2>

      {/* 확인 버튼 */}
      <AppButton
        onConfirm={type === 'CONFIRM' ? onConfirm : onCancel}
        message={onConfirmTitle || '확인'}
        className="f-one-pop"
      />
      {type === 'CONFIRM' && (
        <AppButton
          onConfirm={onCancel}
          backgroundColor="#D4D4D4"
          boxShadowColor="#B7B7B7"
          style={{
            marginTop: 10,
          }}
          message={onCancelTitle || '취소'}
        />
      )}
    </div>
  );
};
